{
  "portals": {
    "lp": "Motive Partners | Investor Portal",
    "gp": "Motive Partners | Workbench",
    "lp-co-invest": "Motive Partners | LP Co-Investment Portal",
    "gp-co-invest": "Motive Partners | GP Co-Investment Portal",
    "subscription-templates": "Motive Partners | Subscriptions templates"
  }
}
